import { client } from '../utils'
import { lms as endpoints, lti as ltiEndpoints } from '../api_urls'

const defaultErrorMessage =
  'An unexpected error occurred. Please try again or contact support.'
const parseErrorMessage = error =>
  (error.response && error.response.data.error) || defaultErrorMessage

export const SET_ASSESSMENT_GROUPS = 'SET_ASSESSMENT_GROUPS'
export const SET_CANVAS_URL = 'SET_CANVAS_URL'
export const SET_CANVAS_TOKEN = 'SET_CANVAS_TOKEN'
export const SET_CANVAS_TOKEN_VERIFIED = 'SET_CANVAS_TOKEN_VERIFIED'
export const SET_CANVAS_COURSENUM = 'SET_CANVAS_COURSENUM'
export const SET_CANVAS_ASSIGNMENTS = 'SET_CANVAS_ASSIGNMENTS'
export const SET_CANVAS_EXTERNAL_TOOLS = 'SET_CANVAS_EXTERNAL_TOOLS'

export const setAssessmentGroups = assessmentGroups => ({
  type: SET_ASSESSMENT_GROUPS,
  assessmentGroups,
})

export const setCanvasUrl = canvasUrl => ({
  type: SET_CANVAS_URL,
  canvasUrl,
})

export const setCanvasToken = canvasToken => ({
  type: SET_CANVAS_TOKEN,
  canvasToken,
})

export const setCanvasTokenVerified = canvasTokenVerified => ({
  type: SET_CANVAS_TOKEN_VERIFIED,
  canvasTokenVerified,
})

export const setCanvasCoursenum = canvasCoursenum => ({
  type: SET_CANVAS_COURSENUM,
  canvasCoursenum,
})

export const setCanvasAssignments = canvasAssignments => ({
  type: SET_CANVAS_ASSIGNMENTS,
  canvasAssignments,
})

export const setCanvasExternalTools = canvasExternalTools => ({
  type: SET_CANVAS_EXTERNAL_TOOLS,
  canvasExternalTools,
})

export const getCanvasSettings = () => {
  return async dispatch => {
    try {
      const response = await client.get(endpoints.show())
      const { canvasUrl, canvasCoursenum } = response.data
      dispatch(setCanvasUrl(canvasUrl))
      dispatch(setCanvasCoursenum(canvasCoursenum))
      if (canvasUrl) {
        try {
          await dispatch(verifyCanvasToken())
        } catch (error) {
          // no-op:
        }
      }
      if (canvasUrl && canvasCoursenum) {
        try {
          await dispatch(getCanvasExternalTools())
        } catch (error) {
          // no-op:
        }
      }
    } catch (error) {
      // no-op:
    }
  }
}

export const getCanvasExternalTools = () => {
  return async dispatch => {
    try {
      const response = await client.get(endpoints.externalTools())
      dispatch(setCanvasExternalTools(response.data))
    } catch (error) {
      // no-op:
    }
  }
}

export const createCourseLink = () => {
  return async (dispatch, getState) => {
    try {
      const response = await client.post(endpoints.createCourseLink())
      dispatch(
        setCanvasExternalTools({
          ...getState().canvasExternalTools,
          course_link: response.data,
        })
      )
    } catch (error) {
      throw parseErrorMessage(error)
    }
  }
}

export const getCanvasAssignments = () => {
  return async dispatch => {
    try {
      const response = await client.get(endpoints.canvasAssignments())
      dispatch(setCanvasAssignments(response.data.assignments))
    } catch (error) {
      throw parseErrorMessage(error)
    }
  }
}

export const getAssessmentGroups = () => {
  return async dispatch => {
    const response = await client.get(ltiEndpoints.getAssessmentGroups())
    dispatch(setAssessmentGroups(response.data.groups))
  }
}

export const getCanvasCourses = () => {
  return async () => {
    try {
      const response = await client.get(endpoints.courses())
      // the server includes an empty placeholder with and ID of -1, so we need
      // to filter it out.  Also, we filter instead of just .slice(1) just in
      // case somebody ever changes that without fixing it here too.
      return response.data.courses.filter(course => course.id > 0)
    } catch (error) {
      throw parseErrorMessage(error)
    }
  }
}

export const updateCanvasUrl = canvasUrl => {
  return async () => {
    try {
      await client.post(endpoints.save(), {
        canvasUrl,
      })
    } catch (error) {
      throw parseErrorMessage(error)
    }
  }
}

export const verifyCanvasToken = () => {
  return async dispatch => {
    try {
      await client.post(endpoints.verifyCanvasToken())
      dispatch(setCanvasTokenVerified(true))
    } catch (error) {
      throw parseErrorMessage(error)
    }
  }
}

export const updateCanvasCoursenum = canvasCoursenum => {
  return async dispatch => {
    try {
      await client.post(endpoints.save(), {
        canvasCoursenum,
      })
      dispatch(setCanvasCoursenum(canvasCoursenum))
    } catch (error) {
      throw parseErrorMessage(error)
    }
  }
}

export const createCanvasAssignment = assessmentPk => {
  return async dispatch => {
    try {
      await client.post(endpoints.createCanvasAssignment({ id: assessmentPk }))
      await dispatch(getCanvasAssignments())
    } catch (error) {
      throw parseErrorMessage(error)
    }
  }
}

export const deleteCanvasAssignment = assessmentPk => {
  return async dispatch => {
    try {
      await client.post(endpoints.deleteCanvasAssignment({ id: assessmentPk }))
      await dispatch(getCanvasAssignments())
    } catch (error) {
      throw parseErrorMessage(error)
    }
  }
}
